import { Box, Grid2, IconButton, Stack, Typography } from "@mui/material";
import OverviewCard from "./Component/OverviewCard";
import QuickTransactionCard from "./Component/QuickTransactionCard";
import RecentTransactionCard from "./Component/RecentTransactionCard";
import EarningGraph from "./Component/EarningGraph";
import TransactionRatio from "./Component/TransactionRatio";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import {
  FETCH_PROFILE_TYPE,
  FETCH_WALLET_TYPE,
} from "reduxStore/actions/authActionType";

const DashboardPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({
      type: FETCH_PROFILE_TYPE,
    });
    dispatch({
      type: FETCH_WALLET_TYPE,
    });
  }, []);

  return (
    <Box sx={styles.container}>
      <Grid2 container spacing={2} mb={2}>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <OverviewCard />
        </Grid2>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <QuickTransactionCard />
        </Grid2>
      </Grid2>

      <Grid2 container spacing={2} mb={2}>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <EarningGraph />
        </Grid2>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <TransactionRatio />
        </Grid2>
      </Grid2>

      <Grid2 container spacing={2}>
        <Grid2 size={{ xs: 12, md: 12 }}>
          <RecentTransactionCard />
        </Grid2>
      </Grid2>
    </Box>
  );
};
export default DashboardPage;
const styles = {
  container: {
    flexGrow: 1,
  },
};
